import * as React from 'react'

// Components
import LabelWithValue from '@frontrow/console/src/components/common/label-with-value'
// Models
import {type DetailedSchoolAdminT} from '@frontrow/console/src/models/school-admin'
// Styles
import * as style from './school-admin-profile.module.scss'

type Props = {
  schoolAdmin: DetailedSchoolAdminT
}

export default function SchoolAdminProfile(props: Props): React.ReactElement {
  const {
    schoolAdmin: {id, firstName, lastName, position, email, verificationUrl}
  } = props

  const verificationField =
    verificationUrl !== null && verificationUrl !== undefined ? (
      <LabelWithValue name="Verification link" value={verificationUrl} />
    ) : null

  return (
    <div className={style.schoolAdminProfileContainer}>
      {verificationField}
      <LabelWithValue name="ID" value={id} />
      <LabelWithValue name="School Admin Name" value={`${firstName} ${lastName}`} />
      <LabelWithValue name="Position" value={position} />
      <LabelWithValue name="Email" value={email} />
    </div>
  )
}
